export interface EmbeddedListResponse {
    success: boolean;
    message: string;
    _embedded: any;
    pageSize: number;
    page: number;    
    totalSize: number;
    totalPages: number;
    size: number;
}
export interface ListResponse<T> {
    success: boolean;
    message: string;
    items: T[];
    pageSize: number;
    page: number;    
    totalSize: number;
    totalPages: number;
    size: number;
}

export function convertListResponse<T1, T2>(resp: ListResponse<T1>) : ListResponse<T2> {
    var resp2: ListResponse<T2> = { 
        items: [],
        message: resp.message,
        page: resp.page,
        pageSize: resp.pageSize,
        size: resp.size,
        success: resp.success,
        totalPages: resp.totalPages,
        totalSize: resp.totalSize
    };
    return resp2;
}